import alt from 'components/Dispatcher';
import TeamSource from 'sources/TeamSource';
import TeamActions from 'actions/TeamActions';
import Moment from 'moment';

export class TeamStore{
  constructor() {
    this.state = {
      teams: [],
      starts: [],
      params: {},
      params2: {},
      loading: false,
      date: Moment()
    };
    this.registerAsync(TeamSource);
    this.bindListeners({
      handleFetchTeams: TeamActions.FETCH_TEAMS,
      handleUpdateDay: TeamActions.UPDATE_DAY,
      handleFetchTeamStarts: TeamActions.FETCH_TEAM_STARTS,
      handleUpdateTeams: TeamActions.UPDATE_TEAMS,
      handleUpdateTeamStarts: TeamActions.UPDATE_TEAM_STARTS,
      handleFetchLoading: TeamActions.FETCH_LOADING,
      handleFetchSuccess: TeamActions.FETCH_SUCCESS,
      handleFetchError: TeamActions.FETCH_ERROR,
      handleRefreshTeam: TeamActions.REFRESH_TEAM
    });
  }
  handleFetchTeams(params) {
    this.setState({params});
    this.getInstance().getRemoteTeams();
  }
  handleUpdateDay(date){
    this.setState({date})
  }
  handleFetchTeamStarts(params2){
    this.setState({params2});
    this.getInstance().getRemoteTeamStarts();
  }
  handleUpdateTeams(teams){
    this.setState({teams});
  }
  handleUpdateTeamStarts(starts) {
    this.setState({starts})
  }
  handleRefreshTeam() {
    this.getInstance().getRemoteTeams();
  }
  handleFetchLoading() {
    this.setState({loading: true});
  }
  handleFetchSuccess() {
    this.setState({loading: false});
  }
  handleFetchError(error) {
    this.setState({error});
  }
}

export default alt.createStore(TeamStore, 'TeamStore');



// WEBPACK FOOTER //
// ./src/stores/TeamStore.js